import moment from 'moment-timezone';

export function getAPIDateFormat(d) {
  return moment(d).tz('UTC').format('YYYYMMDD');
}

export function getAPIDateTimeFormat(d) {
  return moment(d).tz('UTC').format('YYYYMMDDHHmmss');
}

export function getAPIEndDateFormat(d) {
  return `${moment(d).tz('UTC').format('YYYYMMDD')}235959`;
}

export function generateDateRangeFromTimeframe(timeframe) {
  if (!timeframe) {
    return null;
  }
  if (timeframe === 'All' || timeframe === 'Last 30 Days' || timeframe === 'Last 90 Days') {
    // BE can decipher this
    return timeframe;
  }

  const startDate = `${getAPIDateFormat(timeframe.start)}0000`;
  const endDate = getAPIEndDateFormat(timeframe.end);
  return `${startDate}=>${endDate}`;
}

export function generateExactDateRangeFromTimeframe(timeframe) {
  if (!timeframe) {
    return null;
  }

  let dateRange = '';

  dateRange += getAPIDateTimeFormat(timeframe.start);
  dateRange += '=>';
  if (timeframe.end) {
    dateRange += getAPIDateTimeFormat(timeframe.end);
  }

  return dateRange;
}

export function convertSort(filters) {
  let direction = '+';
  if (filters.reverse) {
    direction = '-';
  }

  direction += filters.order;
  return direction;
}

export const formattedHeaders = (headers) => {
  const newHeaders = [];

  headers.map(({ name, index, value }) =>
    newHeaders.push({ name: name.replace(/\s/g, ''), index, value }),
  );

  return newHeaders;
};
